
import React, { lazy, Suspense, useState, useEffect } from 'react';
import LazyRouteFallback from './components/LazyRouteFallback';

const HomePage = lazy(() => import('./pages/home/HomePage'));
const StudentViewPage = lazy(() => import('./pages/dashboard/manager/studentMember/StudentViewPage'));
const IntakePage = lazy(() => import('./pages/intake/IntakePage')); // 4.0 신입생 안내 공개 링크(라이몬앱 10-18)
const InstallPage = lazy(() => import('./pages/install/InstallPage')); // 설치 페이지 /i(라이몬앱 10-23 · weeklyPlan 바로가기와 함께)
const ParentConfirmPage = lazy(() => import('./pages/intake/ParentConfirmPage')); // 학부모 안내 · 확인(라이몬앱 10-18)
const SubjectPickPage = lazy(() => import('./pages/intake/SubjectPickPage')); // 관리 과목 고르기 /s/:token(시몬앱 11-01 · 공명 SA-T1182 ④)

const App: React.FC = () => {
  // Simple routing logic
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  // 개발 검산대(시몬앱 2026-09-15) — 교재테스트 응시 화면을 로그인 없이 본다. 배포본엔 이 가지가 없다.
  if (import.meta.env.DEV && currentPath === '/__booktest') {
    const BookTestHarness = lazy(() => import('./pages/dev/BookTestHarness'));
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <BookTestHarness />
      </Suspense>
    );
  }

  // 4.0 신입생 안내 — /j/:token (로그인 없음)
  if (currentPath === '/i' || currentPath === '/i/') {   // 설치 페이지(공개 · 주공 결 10-23)
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <InstallPage />
      </Suspense>
    );
  }
  const intakeMatch = currentPath.match(/^\/j\/([A-Za-z0-9_-]{43})$/);
  if (intakeMatch) {
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <IntakePage token={intakeMatch[1]} />
      </Suspense>
    );
  }

  const parentMatch = currentPath.match(/^\/p\/([A-Za-z0-9_-]{43})$/);
  if (parentMatch) {
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <ParentConfirmPage token={parentMatch[1]} />
      </Suspense>
    );
  }

  const subjMatch = currentPath.match(/^\/s\/([A-Za-z0-9_-]{43})$/);
  if (subjMatch) {
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <SubjectPickPage token={subjMatch[1]} />
      </Suspense>
    );
  }

  // Check for student-view route
  const studentViewMatch = currentPath.match(/^\/student-view\/(.+)$/);
  if (studentViewMatch) {
    const memberId = studentViewMatch[1];
    return (
      <Suspense fallback={<LazyRouteFallback />}>
        <StudentViewPage memberId={memberId} />
      </Suspense>
    );
  }



  return (
    <Suspense fallback={<LazyRouteFallback />}>
      <HomePage />
    </Suspense>
  );
};

export default App;
